var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20.7697L15.859 16.3909M18.1537 10.5389C18.1537 12.7354 17.3271 14.842 15.8556 16.3952C14.3842 17.9484 12.3885 18.8209 10.3076 18.8209C8.22665 18.8209 6.23095 17.9484 4.75951 16.3952C3.28807 14.842 2.46143 12.7354 2.46143 10.5389C2.46143 8.34235 3.28807 6.23578 4.75951 4.68259C6.23095 3.12941 8.22665 2.25684 10.3076 2.25684C12.3885 2.25684 14.3842 3.12941 15.8556 4.68259C17.3271 6.23578 18.1537 8.34235 18.1537 10.5389V10.5389Z",
    stroke: "#606060",
    strokeWidth: 2.62784,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1538,
    height: 23.3846,
    fill: "white",
    transform: "translate(0.615234 0.307617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.95b99e54520d068548b10a02af1e5cd0.svg";
export { ForwardRef as ReactComponent };